<template>
  <div>
    <app-layout>
      <template v-slot:header>
        <Header :title="$t('creating_fykk_template')"
                :isFilter="false"/>
      </template>
      <template v-slot:header-mobile>
        <HeaderMobile :title="$t('creating_fykk_template')"
                      :isFilter="false"/>
      </template>


      <div class="row align-items-center" v-if="data">
        <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3 ellipsis-1">
          <label class="col-form-label mr-1 p-0">{{ $t('faculty') }}:</label>
          {{ getLocaleText(data, 'faculty_name', '-') }}
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3 ellipsis-1">
          <label class="col-form-label mr-1 p-0">{{ $t('semester') }}:</label>
          {{ data.academic_year + ' / ' + getLocaleText(data, 'semester_text', '-') }}
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3 ellipsis-1">
          <label class="col-form-label mr-1 p-0">{{ $t('date') }}:</label>
          {{ data.date }}
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3 ellipsis-1">
          <label class="col-form-label mr-1 p-0">{{ $t('subject') }}:</label>
          {{ getLocaleText(data, 'type_text', '-') }}
        </div>
      </div>

      <div class="row mb-5 align-items-center" v-if="data">
        <div class="col-12">
          <div class="row">
            <div class="col-xl-3 col-md-4 col-sm-6 col-xs-12"
                 v-if="['double_major', 'minor_application'].includes(data.type)">
              <b-form-group :label="$t('status')">
                <b-form-select v-model="form.preference_status" :options="options"></b-form-select>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6 col-xs-12" v-else>
              <b-form-group :label="$t('status')" v-if="data.type !== 'course_transfer'">
                <b-form-select v-model="form.status">
                  <option :value="null">{{ $t('select') }}</option>
                  <option value="approved">{{ $t('approved') }}</option>
                  <option value="declined">{{ $t('declined') }}</option>
                </b-form-select>
              </b-form-group>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="row align-items-center" v-if="students.length > 0 && !loading">
            <div class="col-12">
              <table class="table table-striped table-bordered">
                <thead>
                <tr>
                  <th class="w-40">
                    <b-form-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="selectAll"
                        @change="toggleSelectAll"
                    >
                      {{ $t('select_all') }}
                    </b-form-checkbox>
                  </th>
                  <th>{{ $t('student_number') }}</th>
                  <th>{{ $t('name') }}</th>
                  <th>{{ $t('surname') }}</th>
                  <th>{{ $t('status') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in students" :key="row.id">
                  <td>
                    <b-form-checkbox v-model="related_ids" :value="row.id"></b-form-checkbox>
                  </td>
                  <td>{{ row.student_number }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.surname }}</td>
                  <td v-if="['double_major', 'minor_application'].includes(data.type)">
                    {{
                      form.preference_status === 'approved_academic_unit_office' ? $t('approved_academic_unit_office') : $t('declined_academic_unit_office')
                    }}
                  </td>
                  <td v-else>{{ getLocaleText(row, 'status_name') }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="loading" class="col-12 border vh-100 d-flex justify-content-center align-items-center">
            <Loading :show="loading"/>
          </div>
        </div>

        <div class="col-12 mt-3">
          <b-button @click="createDocument"
                    type="button"
                    variant="primary"
                    class="btn-lg">
            {{ $t('create_document').toUpperCase() }}
          </b-button>
        </div>
      </div>
    </app-layout>
  </div>
</template>

<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";
// Services
import BoardDecisionService from "@/services/BoardDecisionService";
import LeaveOfAbsenceService from "@/services/LeaveOfAbsenceService";
import CourseTransferService from "@/services/CourseTransferService";
import MinorApplicationService from "@/services/MinorApplicationService";
import DoubleMajorApplicationService from "@/services/DoubleMajorApplicationService";
// Other
import qs from "qs";
import {EventBus} from "@/main";

export default {
  components: {
    AppLayout,
    Header,
    HeaderMobile
  },
  data() {
    return {
      id: this.$route.params.id,
      form: {},
      type: null,
      data: null,
      loading: false,
      students: [],
      related_ids: [],
      preference_statusOptions: [
        {text: this.$t('application_preference_status.placed'), value: 'placed'},
        {text: this.$t('application_preference_status.not_placed'), value: 'not_placed'},
        {text: this.$t('application_preference_status.registered'), value: 'registered '}
      ],
      selectAll: false,
      isIndeterminate: false,
      options: [
        {text: this.$t("approved_academic_unit_office"), value: 'approved_academic_unit_office'},
        {text: this.$t("declined_academic_unit_office"), value: 'declined_academic_unit_office'},
      ],
    }
  },
  metaInfo() {
    return {
      title: this.$t("creating_fykk_template")
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      if (this.id > 0) {
        this.loading = true;
        BoardDecisionService.get(this.id)
            .then(response => {
              this.data = response.data.data;
              if (this.data.type === 'course_transfer') {
                this.getCourseTransfers();
              }
            })
            .catch(error => {
              if (error.data && error.data.message) {
                this.$toast.error(this.$t('api.' + error.data.message));
              }
            })
            .finally(() => {
              // Only stop loading here if we didn't start another request
              if (this.data && this.data.type !== 'course_transfer') {
                this.loading = false;
              }
            });
      }
    },
    getStudents() {
      if (!this.data) return;

      if (this.data.type === 'minor_application') {
        this.getMinorApplications();
      } else if (this.data.type === 'double_major') {
        this.getMajorApplications();
      } else {
        this.getLeaveAbsences();
      }
    },
    getLeaveAbsences() {
      this.loading = true;
      const config = {
        params: {
          filter: {
            status: 'approved',
            academic_year: this.data.academic_year,
            faculty_code: this.data.faculty_code
          },
          limit: 999,
          sort: 'id'
        },
        paramsSerializer: (params) => qs.stringify(params, {encode: false}),
      };
      LeaveOfAbsenceService.getAll(config)
          .then(response => {
            this.students = response.data.data;
          })
          .catch(e => {
            if (e.data && e.data.message) {
              this.$toast.error(this.$t('api.' + e.data.message));
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getCourseTransfers() {
      this.loading = true;
      const config = {
        params: {
          filter: {
            status: this.form.status,
            academic_year: this.data.academic_year,
            faculty_code: this.data.faculty_code
          },
          limit: 999,
          sort: 'id'
        },
        paramsSerializer: (params) => qs.stringify(params, {encode: false}),
      };
      CourseTransferService.getAll(config)
          .then(response => {
            this.students = response.data.data;
          })
          .catch(e => {
            if (e.data && e.data.message) {
              this.$toast.error(this.$t('api.' + e.data.message));
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getMinorApplications() {
      this.loading = true;
      const config = {
        params: {
          filter: {
            preference_status: this.form.preference_status,
          },
          limit: 999,
          sort: 'id'
        },
        paramsSerializer: (params) => qs.stringify(params, {encode: false}),
      };
      MinorApplicationService.studentAffairsIndex(config)
          .then(response => {
            this.students = response.data.data;
          })
          .catch(e => {
            if (e.data && e.data.message) {
              this.$toast.error(this.$t('api.' + e.data.message));
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getMajorApplications() {
      this.loading = true;
      const config = {
        params: {
          filter: {
            preference_status: this.form.preference_status,
          },
          limit: 999,
          sort: 'id'
        },
        paramsSerializer: (params) => qs.stringify(params, {encode: false}),
      };
      DoubleMajorApplicationService.studentAffairsIndex(config)
          .then(response => {
            this.students = response.data.data;
          })
          .catch(e => {
            if (e.data && e.data.message) {
              this.$toast.error(this.$t('api.' + e.data.message));
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    async createDocument() {
      if (this.related_ids.length === 0) {
        return;
      }
      let data = {
        status: "approved",
        related_ids: this.related_ids
      };
      BoardDecisionService.createDocument(this.data.id, data)
          .then(response => {
            let fileName = this.data.decision_number + '-' + this.data.date + '.pdf'
            EventBus.$emit('pdfViewerModalShow', {pdfFileData: response.data, pdfFileName: fileName});
          })
          .catch(e => {
            if (e.data && e.data.message) {
              var decoder = new TextDecoder("utf-8");
              var data = JSON.parse(decoder.decode(new Uint8Array(e.data)));
              this.$toast.error(this.$t('api.' + data.message));
            }
          })
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.related_ids = this.students.map(s => s.id);
      } else {
        this.related_ids = [];
      }
      this.updateIndeterminate();
    },
    updateIndeterminate() {
      if (this.related_ids.length === 0) {
        this.isIndeterminate = false;
        this.selectAll = false;
      } else if (this.related_ids.length === this.students.length) {
        this.isIndeterminate = false;
        this.selectAll = true;
      } else {
        this.isIndeterminate = true;
        this.selectAll = false;
      }
    }
  },
  watch: {
    'form.status': {
      immediate: true,
      handler() {
        this.getStudents();
      }
    },
    'form.preference_status'() {
      this.getStudents();
    },
    related_ids() {
      this.updateIndeterminate();
    },
  }
}
</script>
